import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { clsx } from "clsx/lite";

type PressableBoxMobileProps = {
  onClick: () => void;
  icon: IconDefinition;
  primaryText: string;
  secondaryText: string;
};

export function PressableBoxMobile({
  onClick,
  icon,
  primaryText,
  secondaryText,
}: PressableBoxMobileProps) {
  return (
    <button
      onClick={onClick}
      className={clsx(
        "h-20",
        "p-4",
        "border-neutral",
        "border",
        "rounded-lg",
        "bg-white",
        "shadow-xs",
        "flex",
        "justify-center",
        "items-center",
      )}
    >
      <div
        className={clsx(
          "flex",
          "flex-row",
          "gap-4",
          "justify-start",
          "items-center",
          "w-full",
          "text-left",
        )}
      >
        <FontAwesomeIcon icon={icon} className="text-font-black text-lg" />
        <div className="flex flex-col leading-4">
          <div className="font-medium text-base">{primaryText}</div>
          <div className="text-font-secondary">{secondaryText}</div>
        </div>
      </div>
    </button>
  );
}
